import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'

type PopupFooterProps = {
	isDisabledApply?: boolean
	onApply?(): void
	onRemove?(): void
}
export default function PopupFooter({
	isDisabledApply,
	onApply,
	onRemove,
}: PopupFooterProps) {
	const { t } = useTranslation()

	return (
		<div className='flex border-t p-3'>
			{onRemove && (
				<Button size='sm' onClick={onRemove}>
					{t('app.delete', { defaultValue: 'Delete' })}
				</Button>
			)}
			<div className='ml-auto flex items-center space-x-1'>
				<Button
					tabIndex={-2}
					variant='primary'
					type='submit'
					size='sm'
					onClick={onApply}
					disabled={isDisabledApply}
				>
					{t('app.apply', { defaultValue: 'Apply' })}
				</Button>
			</div>
		</div>
	)
}
